import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DomSanitizer} from '@angular/platform-browser';
import {marked} from 'marked';

@Component({
  selector: 'app-markdown-dialog',
  templateUrl: './markdown-dialog.component.html',
  styleUrl: './markdown-dialog.component.scss',
  standalone: false
})
export class MarkdownDialogComponent implements OnInit {
  markdownHtml = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {markdown: string},
    private readonly sanitizer: DomSanitizer,
    private readonly dialogRef: MatDialogRef<MarkdownDialogComponent>
  ) {}

  ngOnInit(): void {
    const result = marked(this.data.markdown);

    if (result instanceof Promise) {
      result.then(rawHtml => {
        this.markdownHtml = this.sanitizer.sanitize(1, rawHtml) || '';
      });
    } else {
      this.markdownHtml = this.sanitizer.sanitize(1, result) || '';
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
